export default {
  IN: "in",
  OUT: "out"
};
